/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getCheckoutGuide } from '../fn/public-documentation/get-checkout-guide';
import { GetCheckoutGuide$Params } from '../fn/public-documentation/get-checkout-guide';


/**
 * Public endpoints for payment documentation guides
 */
@Injectable({ providedIn: 'root' })
export class PublicDocumentationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCheckoutGuide()` */
  static readonly GetCheckoutGuidePath = '/v1/api/ui/public/docs/open-notification';

  /**
   * Get checkout integration documentation.
   *
   * Serves the public HTML guide for payment checkout integration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCheckoutGuide()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCheckoutGuide$Response(params?: GetCheckoutGuide$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getCheckoutGuide(this.http, this.rootUrl, params, context);
  }

  /**
   * Get checkout integration documentation.
   *
   * Serves the public HTML guide for payment checkout integration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCheckoutGuide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCheckoutGuide(params?: GetCheckoutGuide$Params, context?: HttpContext): Observable<Blob> {
    return this.getCheckoutGuide$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
